(window as any).process = {
  env: {DEBUG: undefined},
};

import 'hammerjs/hammer';

(window as any).global = window;

/**
 * `requestIdleCallback` polyfill so that we load lesson thumbnails
 * on iOS WKWebView. Using setTimeout instead.
 */
if (typeof window.requestIdleCallback !== 'function') {
  window.requestIdleCallback = (
    callback: IdleRequestCallback,
    _options?: IdleRequestOptions,
  ): number => {
    const start = Date.now();
    return window.setTimeout(() => {
      callback({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
      });
    }, 1);
  };
  window.cancelIdleCallback = (id: number) => window.clearTimeout(id);
}
